import { Ally } from "../ally/Ally";
import { IInitLocation, Location } from "./Location";

export class Dungeon extends Location {
}